<template>
  <div>
    <ProposalTableCustomer/>
  </div>
</template>

<script>
import ProposalTableCustomer from '@/components/backend/proposal/ProposalTableCustomer.vue'

export default {
  name: 'ProposalListCustomer',
  components: {
    ProposalTableCustomer
  }
}
</script>

<style scoped>

</style>
